export function secondsToTime(time) {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time - (minutes * 60));

    return `${minutes}:${pad(seconds, 2, "0")}`
}

function pad(num, size, char) {
    num = num.toString();
    while (num.length < size) num = char + num;
    return num;
}
export function round2Decimal (num) { return Math.round(num * 100) / 100 } 